import './index.css';
import 'modern-normalize';

import { MantineProvider, Text } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { RouterProvider } from 'react-router-dom';

import { ProfileProvider } from './domains/profile/profile-provider';
import { router } from './router';

import styles from './app.module.css';

import 'dayjs/locale/ru';
import 'dayjs/locale/en';
import 'dayjs/locale/hy-am';

import { ReactNode } from 'react';
import { i18n } from '@lingui/core';
import { Trans } from '@lingui/macro';
import { I18nProvider, useLingui } from '@lingui/react';
import { DatesProvider } from '@mantine/dates';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { registerSW } from 'virtual:pwa-register';

import { detectLang, initLocal } from './lib/local/local';
// @ts-expect-error add types for import locals messages
import { messages as en } from './locales/en.po';
// @ts-expect-error add types for import locals messages
import { messages as hy } from './locales/hy.po';
// @ts-expect-error add types for import locals messages
import { messages as ru } from './locales/ru.po';

registerSW({ immediate: true });

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(duration);

dayjs.tz.setDefault('Asia/Yerevan');

initLocal({ en, hy, ru });

const LocalDateProvider = ({ children }: { children: ReactNode }) => {
  const local = useLingui();
  const lang = detectLang();

  dayjs.locale(lang === 'hy' ? 'hy-am' : lang);

  return (
    <DatesProvider settings={{ locale: local.i18n.locale }}>
      {children}
    </DatesProvider>
  );
};

export default function App() {
  return (
    <I18nProvider i18n={i18n}>
      <MantineProvider withGlobalStyles withNormalizeCSS>
        <Notifications />
        <LocalDateProvider>
          <div className={styles.appContainer}>
            <ProfileProvider>
              <RouterProvider router={router} />
              <Text ta="center" size="xs" color="#cdcdcd">
                <Trans>Версия</Trans>: {import.meta.env.VITE_APP_VERSION}
              </Text>
            </ProfileProvider>
          </div>
        </LocalDateProvider>
      </MantineProvider>
    </I18nProvider>
  );
}
